/** Firebase Auth failures caused by user input or account state — not app defects. */
const EXPECTED_USER_AUTH_ERROR_CODES = new Set([
	'auth/invalid-credential',
	'auth/invalid-login-credentials',
	'auth/wrong-password',
	'auth/user-not-found',
	'auth/invalid-email',
	'auth/user-disabled',
	'auth/too-many-requests',
	/** Second signInWithPopup while the first is still opening (e.g. double-click). */
	'auth/cancelled-popup-request',
	/** User closed the Google popup without signing in. */
	'auth/popup-closed-by-user',
]);

export function firebaseAuthErrorCode(error: unknown): string | undefined {
	return (error as { code?: string })?.code;
}

/** True when the failure is an expected sign-in / credential rejection (do not report to Sentry). */
export function isExpectedFirebaseAuthUserError(error: unknown): boolean {
	const code = firebaseAuthErrorCode(error);
	return !!code && EXPECTED_USER_AUTH_ERROR_CODES.has(code);
}
